export const handleBalanceAccordionClick = (
  value: string,
  navigate: any,
  isWeek?: boolean,
  timeFrame: 'past' | 'upcoming' | 'current' = 'past'
) => {
  navigate(`/balance/invoice/${isWeek ? 'week' : 'day'}/${timeFrame}`);
  localStorage.setItem('balance_date', value);
};
